import { Link, useParams } from 'react-router-dom';
import { ArrowLeftOutlined, DatabaseOutlined } from '@ant-design/icons';

import { PageHeader } from '../../../components/shared';
import { Badge, Button, Empty, Skeleton } from '../../../components/ui';
import { useDieuHuong, useDuongDan } from '../../../hooks/useDuongDan';
import { useT } from '../../../i18n';
import { KhuonTab } from '../components/khuon/KhuonTab';
import { NhanLoaiNguon } from '../components/chung/LuoiNguon';
import { DaiLoi } from '../components/chung/VungDuLieu';
import { useDanhSachNguon } from '../hooks/useChung';
import { theoKhuon } from './KhuonView';

/** Truy vấn mẫu của MỘT nguồn (`/tro-ly-ai/khuon/:nguon`) — nhóm, khuôn, trình soạn, công tắc chế độ. */
export function KhuonChiTietView() {
  const { t } = useT();
  const duongDan = useDuongDan();
  const dieuHuong = useDieuHuong();
  const { nguon: sourceId = '' } = useParams();
  const nguonQ = useDanhSachNguon();
  const nguon = nguonQ.data?.find((s) => s.id === sourceId);

  const breadcrumbGoc = [
    { label: t('nav.nhom.troLiAi') },
    { label: t('nav.muc.truyVanMau'), onClick: () => dieuHuong('/tro-ly-ai/khuon') },
  ];

  const quayLai = (
    <Link to={duongDan('/tro-ly-ai/khuon')}>
      <Button variant="ghost" size="sm" icon={<ArrowLeftOutlined />}>
        {t('troLyAiKhuonView.tatCaNguon')}
      </Button>
    </Link>
  );

  if (nguonQ.isPending) {
    return (
      <div className="space-y-4 p-4" aria-busy="true">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (nguonQ.error) {
    return (
      <div className="space-y-4 p-4">
        <PageHeader breadcrumb={breadcrumbGoc} title={t('troLyAiKhuonView.tieuDe')} actions={quayLai} />
        <div className="rounded-lg border border-default bg-surface">
          <DaiLoi loi={nguonQ.error} onThuLai={() => void nguonQ.refetch()} />
        </div>
      </div>
    );
  }

  if (!nguon) {
    return (
      <div className="space-y-4 p-4">
        <PageHeader breadcrumb={breadcrumbGoc} title={t('troLyAiKhuonView.tieuDe')} actions={quayLai} />
        <div className="rounded-lg border border-default bg-surface">
          <Empty
            icon={DatabaseOutlined}
            title={t('troLyAiKhuonView.khongCoNguon')}
            description={t('troLyAiKhuonView.khongCoNguonMoTa', { ma: sourceId })}
          />
        </div>
      </div>
    );
  }

  const laApi = nguon.kind === 'api';
  const coKhuon = theoKhuon(nguon);

  return (
    <div className="flex h-full flex-col bg-subtle">
      <div className="flex-1 space-y-4 overflow-y-auto p-4">
        <PageHeader
          breadcrumb={[...breadcrumbGoc, { label: nguon.name }]}
          title={nguon.name}
          subtitle={laApi ? t('troLyAiKhuonView.nguonApiGhi') : nguon.moTa || undefined}
          actions={
            <div className="flex flex-wrap items-center gap-2">
              <NhanLoaiNguon s={nguon} />
              <Badge variant={coKhuon ? 'primary' : 'neutral'}>
                {coKhuon ? t('troLyAiKhuonView.theoKhuon') : t('troLyAiKhuonView.theoBanKhai')}
              </Badge>
              {quayLai}
            </div>
          }
        />
        {/* `key` theo nguồn: đổi nguồn là dựng lại trình soạn, bản nháp của nguồn này không sang nguồn kia. */}
        <KhuonTab key={nguon.id} sourceId={nguon.id} laApi={laApi} diaChiGoc={nguon.api?.baseUrl ?? ''} />
      </div>
    </div>
  );
}
